import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Assets/img/logo.png";
function MobileMenuModal() {
  return (
    <>
      <button
        className="offcanvas-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasExample"
        aria-controls="offcanvasExample"
      >
        <span className="line"></span>
        <span className="line"></span>
        <span className="line"></span>
      </button>

      <div
        className="offcanvas offcanvas-start"
        tabindex="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas-header">
          <div className="offcanvas-logo">
            <Link to="/">
              <img src={Logo} alt="#" />
            </Link>
          </div>
          <button
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="fi-rr-cross"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="offcanvas-menu">
            <ul className="list-none">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/webfeature">Features</NavLink>
              </li>
              <li>
                <NavLink to="/websubscription">Package & Pricing</NavLink>
              </li>
              <li>
                <NavLink to="/aboutus">About us</NavLink>
              </li>
              <li>
                <NavLink to="/blog">Blog</NavLink>
              </li>
            </ul>
            <div className="offcanvas-menu-btn">
              <Link to="/demorequest" className="theme-btn">
                Demo Request
              </Link>
            </div>
            <div className="offcanvas-social">
              <h4 className="follow-title">Follow Us:</h4>
              <ul className="list-none">
                <li>
                  <a href="https://twitter.com" target="_blank">
                    <i className="icofont-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://facebook.com" target="_blank">
                    <i className="icofont-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com" target="_blank">
                    <i className="icofont-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://linkedin.com" target="_blank">
                    <i className="icofont-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileMenuModal;
